export function escapeRegExp(value) {
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}


// WEBPACK FOOTER //
// ./lib/core/regexpz.js